import * as ACTION_TYPES from './actiontypes';

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.BEGIN_MULTISELECT: {
      const { payload } = action;

      if (Array.isArray(payload.item)) {
        return {
          ...state,
          isMultiselect: true,
          multiselectItems: payload.item.map(x => x.encounterCmsCodeId)
        };
      }

      return {
        ...state,
        isMultiselect: true,
        multiselectItems: [payload.item.encounterCmsCodeId]
      };
    }

    case ACTION_TYPES.END_MULTISELECT: {
      return {
        ...state,
        isMultiselect: false,
        multiselectItems: []
      };
    }

    case ACTION_TYPES.SELECT_ITEM_MULTISELECT: {
      const { payload } = action;

      const nextMultiselectItems = [
        ...state.multiselectItems,
        payload.item.encounterCmsCodeId
      ];

      return {
        ...state,
        multiselectItems: nextMultiselectItems
      };
    }

    case ACTION_TYPES.DESELECT_ITEM_MULTISELECT: {
      const { payload } = action;

      const isNotMatch = x => x !== payload.item.encounterCmsCodeId;
      const nextMultiselectItems = state.multiselectItems.filter(isNotMatch);

      return {
        ...state,
        multiselectItems: nextMultiselectItems,
        isMultiselect: nextMultiselectItems.length > 0
      };
    }

    case ACTION_TYPES.APPROVE_DX_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Approving DX'
      };
    }

    case ACTION_TYPES.APPROVE_DX_SUCCESS: {
      const { payload: { listItems } } = action;

      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        dxList: { listItems },
        isMultiselect: false,
        multiselectItems: []
      };
    }

    case ACTION_TYPES.APPROVE_DX_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.UNAPPROVE_DX_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Unapproving DX'
      };
    }

    case ACTION_TYPES.UNAPPROVE_DX_SUCCESS: {
      const { payload: { listItems } } = action;

      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        dxList: { listItems },
        isMultiselect: false,
        multiselectItems: []
      };
    }

    case ACTION_TYPES.UNAPPROVE_DX_FAILURE: {
      return {
        ...state,
        isLoading: false,
        loadingMessage: ''
      };
    }

    case ACTION_TYPES.ADD_DX_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loadingMessage: 'Adding DX'
      };
    }

    case ACTION_TYPES.ADD_DX_SUCCESS: {
      const { payload: { listItems } } = action;

      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        dxList: {
          listItems: listItems.length === 0 ? state.dxList.listItems : listItems
        },
        isMultiselect: false,
        multiselectItems: []
      };
    }

    case ACTION_TYPES.ADD_DX_FAILURE: {
      return { ...state, isLoading: false, loadingMessage: '' };
    }

    case ACTION_TYPES.REMOVE_DX_REQUEST: {
      return { ...state, isLoading: true, loadingMessage: 'Removing DX' };
    }

    case ACTION_TYPES.REMOVE_DX_SUCCESS: {
      const { payload: { listItems } } = action;
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        dxList: { listItems },
        isMultiselect: false,
        multiselectItems: []
      };
    }

    case ACTION_TYPES.REMOVE_DX_FAILURE: {
      return { ...state, isLoading: false, loadingMessage: '' };
    }

    case ACTION_TYPES.UNREMOVE_DX_REQUEST: {
      return { ...state, isLoading: true, loadingMessage: 'Unremoving DX' };
    }

    case ACTION_TYPES.UNREMOVE_DX_SUCCESS: {
      const { payload: { listItems } } = action;
      return {
        ...state,
        isLoading: false,
        loadingMessage: '',
        dxList: { listItems },
        isMultiselect: false,
        multiselectItems: []
      };
    }

    case ACTION_TYPES.UNREMOVE_DX_FAILURE: {
      return { ...state, isLoading: false, loadingMessage: '' };
    }

    case ACTION_TYPES.HYDRATE: {
      const { payload: { listItems } } = action;

      return {
        ...state,
        dxList: { ...state.dxList, listItems }
      };
    }

    default: {
      throw Error('dxWorkSection reducer default should never be hit')
    }
  }
};

export default reducer;
